export default __webpack_public_path__ + "static/media/Numbers_06.77422690.png";